import LoginOk from '../views/login-ok/LoginOk.vue';

export default [
  {
    path: '/loginOk',
    name: 'LoginOk',
    component: LoginOk,
    meta: {
      title: 'Login Ok',
      staticBreadCrumbs: [],
    },
  },
  {
    path: '/loginOkTutor',
    name: 'loginOkTutor',
    component: LoginOk,
    meta: {
      title: 'Login Ok',
      staticBreadCrumbs: [],
    },
  },
];
